import { ApplicationState } from '../../store/rootReducer';
import { DeepReadonly } from 'utility-types';

export const getUserExpiryDate = (state: ApplicationState): DeepReadonly<Date | null> =>
    state.authentication.user ? state.authentication.user.dateOfUserExpiry : null;

export const getUserTenantDomain = (state: ApplicationState): DeepReadonly<string | null> =>
    state.authentication.user ? state.authentication.user.tenantHost : null;
